import React from 'react';
import { FaArrowRight, FaStar, FaGraduationCap, FaComments } from 'react-icons/fa';
import { AiFillCheckSquare } from 'react-icons/ai';

function CourseCardsGrid() {
    const courses = [
        {
            name: 'Básico',
            tense: 'PRESENTE',
            color: 'from-emerald-500 to-teal-600',
            badgeColor: 'bg-emerald-100 text-emerald-700',
            outcomes: [
                'Falar sobre você, sua família e amigos',
                'Descrever lugares como seu bairro e cidade',
                'Conversar sobre sua rotina e hobbies'
            ],
            stats: {
                students: '4500+',
                reviews: '900+',
                rating: '4.8'
            },
            link: 'https://www.udemy.com/course/curso-de-ingles-basico-adquira-uma-base-solida-no-idioma/?referralCode=DAD28CA36F4E068DB9E8'
        },
        {
            name: 'Intermediário 1',
            tense: 'FUTURO',
            color: 'from-orange-500 to-red-500',
            badgeColor: 'bg-orange-100 text-orange-700',
            outcomes: [
                'Falar sobre seus planos pessoais e profissionais',
                'Fazer previsões sobre mudanças na sua vida',
                'Descrever situações hipotéticas'
            ],
            stats: {
                students: '650+',
                reviews: '150+',
                rating: '4.8'
            },
            link: 'https://www.udemy.com/course/curso-de-ingles-intermediario-90-em-ingles-com-legendas/?referralCode=CAADBF2564957289B935'
        },
        {
            name: 'Intermediário 2',
            tense: 'PASSADO',
            color: 'from-blue-600 to-slate-700',
            badgeColor: 'bg-blue-100 text-blue-700',
            outcomes: [
                'Contar histórias sobre sua vida e experiências',
                'Falar sobre viagens e eventos que participou',
                'Descrever experiências acadêmicas e profissionais'
            ],
            stats: {
                students: '350+',
                reviews: '60+',
                rating: '4.8'
            },
            link: 'https://www.udemy.com/course/curso-de-ingles-intermediario-2-lane-antunes/?referralCode=EB310BD715B67485024A'
        }
    ];

    return (
        <div className="w-full flex flex-col items-center gap-12 py-16 md:py-24 px-4 md:px-8">
            {/* Header */}
            <div className="text-center max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                    Nos meus cursos de inglês, você irá aprender a se comunicar nos três tempos verbais essenciais
                </h2>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                    Domine esses fundamentos e você será capaz de se sair bem em praticamente qualquer situação!
                </p>
            </div>

            {/* Cards Grid */}
            <div className="w-full max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {courses.map((course, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 flex flex-col"
                        >
                            {/* Header with gradient */}
                            <div className={`bg-gradient-to-r ${course.color} px-6 md:px-8 py-8`}>
                                <h3 className="text-white text-2xl font-bold mb-3">
                                    {course.name}
                                </h3>
                                <span className={`inline-block ${course.badgeColor} px-4 py-2 rounded-full text-sm font-semibold`}>
                                    {course.tense}
                                </span>
                            </div>

                            {/* Learning Outcomes Section */}
                            <div className="px-6 md:px-8 py-6 flex-1 flex flex-col">
                                <h4 className="text-gray-900 font-bold text-sm md:text-base mb-4">
                                    Você aprenderá a:
                                </h4>
                                <ul className="space-y-3">
                                    {course.outcomes.map((outcome, idx) => (
                                        <li
                                            key={idx}
                                            className="flex gap-3 items-start text-gray-700 text-sm"
                                        >
                                            <AiFillCheckSquare
                                                size={18}
                                                color="#10b981"
                                                className="flex-shrink-0 mt-0.5"
                                            />
                                            <span>{outcome}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Stats Section */}
                            <div className="px-6 md:px-8 py-6 bg-gray-50 border-t border-gray-200">
                                <div className="grid grid-cols-3 gap-2">
                                    <div className="flex flex-col items-center justify-center py-6 px-4 rounded-lg bg-white border border-gray-200">
                                        <FaGraduationCap size={20} className="text-blue-500 mb-2" />
                                        <p className="text-base md:text-lg font-bold text-gray-900">{course.stats.students}</p>
                                        <p className="text-xs text-gray-600 mt-2">Alunos</p>
                                    </div>
                                    <div className="flex flex-col items-center justify-center py-6 px-4 rounded-lg bg-white border border-gray-200">
                                        <FaComments size={20} className="text-green-500 mb-2" />
                                        <p className="text-base md:text-lg font-bold text-gray-900">{course.stats.reviews}</p>
                                        <p className="text-xs text-gray-600 mt-2">Avaliações</p>
                                    </div>
                                    <div className="flex flex-col items-center justify-center py-6 px-4 rounded-lg bg-white border border-gray-200">
                                        <FaStar size={20} className="text-yellow-400 mb-2" />
                                        <p className="text-base md:text-lg font-bold text-gray-900">{course.stats.rating}</p>
                                        <p className="text-xs text-gray-600 mt-2">Classificação</p>
                                    </div>
                                </div>
                            </div>

                            {/* CTA Section */}
                            <div className="px-6 md:px-8 py-6 border-t border-gray-200">
                                <a
                                    href={course.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`w-full bg-gradient-to-r ${course.color} text-white font-semibold py-3 px-6 rounded-full flex items-center justify-center gap-2 hover:shadow-lg transition-all duration-300 hover:scale-105`}
                                >
                                    Ir para o Curso
                                    <FaArrowRight size={14} />
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default CourseCardsGrid;
